import ShareThis from '../components/ShareThis';

export default class StaticArticle {
  constructor(section) {
    this.shareThisEl = section.el.querySelector('[data-sharethis]');

    if (this.shareThisEl) {
      this.sharethis = new ShareThis(this.shareThisEl);
    }
  }

  onSectionUnload() {
    if (this.shareThis) {
      this.sharethis.unload();
    }
  }
}
